import { Component, Input } from '@angular/core';

@Component({
  selector : 'loading-button',
  styleUrls: ['../styles/loading-button.scss'],
  template: `
    <button type="submit" class="loading-btn" [class.user]="isUser" 
    [class.m-progress]="isVisible">{{ text }}</button>
  `,
})
export class LoadingButtonComponent {
  @Input("is-visible") isVisible: boolean;
  @Input("is-user") isUser: boolean;
  @Input("text") text:string;
}
